import React from 'react';
import { motion } from 'framer-motion';
type RevealProps = {
  children: React.ReactNode;
  className?: string;
  delay?: number;
};
export function Reveal({
  children,
  className = '',
  delay = 0
}: RevealProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 28
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-80px'
  }} transition={{
    duration: 0.5,
    ease: 'easeOut',
    delay
  }} className={className} data-id="element-198" data-mp="3bixfsibgydrj">
      {children}
    </motion.div>;
}